module.exports = __webpack_public_path__ + "media/audio6.b76da033.mp3";